import { BOARD_HEIGHT, BOARD_WIDTH, CELL, COLS, ROWS } from "../constants/board.js";

export const buildPathData = (mapDef) => {
	const coords = mapDef.path;
	const px = coords.map(([col, row]) => ({
		x: col * CELL + CELL / 2,
		y: row * CELL + CELL / 2,
	}));
	const set = new Set(
		coords
			.filter(([col, row]) => col >= 0 && col < COLS && row >= 0 && row < ROWS)
			.map(([col, row]) => `${col},${row}`),
	);

	return { coords, px, set };
};

export const clientToBoardPoint = (canvas, clientX = 0, clientY = 0, viewport = {}) => {
	const rect = canvas.getBoundingClientRect();
	const scale = viewport.scale || 1;
	const offsetX = viewport.offsetX || 0;
	const offsetY = viewport.offsetY || 0;
	const screenX = ((clientX - rect.left) / rect.width) * BOARD_WIDTH;
	const screenY = ((clientY - rect.top) / rect.height) * BOARD_HEIGHT;
	const x = (screenX - offsetX) / scale;
	const y = (screenY - offsetY) / scale;

	return { x, y, screenX, screenY };
};

export const pointToCell = (canvas, event, viewport) => {
	const clientX = event.clientX ?? event.touches?.[0]?.clientX ?? 0;
	const clientY = event.clientY ?? event.touches?.[0]?.clientY ?? 0;
	const point = clientToBoardPoint(canvas, clientX, clientY, viewport);
	const col = Math.floor(point.x / CELL);
	const row = Math.floor(point.y / CELL);

	return { ...point, col, row };
};
